import RoomAmenityGenerated, { RoomAmenityGeneratedEntityManager } from './generated/RoomAmenity.generated';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { imageInfoGraphQlDetails } from '@xFrame4/business/Constants';
import { YouTubeVideoInfo, ImageInfo } from '@xFrame4/business/Types';
import ImageGallery, { GalleryImage } from '@xFrame4/business/images/ImageGallery';
import BusinessEntityWithOrderNoHelper from '@xFrame4/business/base/BusinessEntityWithOrderNoHelper';
import { RoomAmenityTranslation } from './RoomAmenityTranslation';


export class RoomAmenityEntityManager extends RoomAmenityGeneratedEntityManager<RoomAmenityTranslation, RoomAmenity>
{
    constructor()
    {
        super({
            createEntity: () => new RoomAmenity(),
        });
    }
}


export class RoomAmenity extends RoomAmenityGenerated<RoomAmenityTranslation>
{
    static _manager: RoomAmenityEntityManager;
    static get manager(): RoomAmenityEntityManager
    {
        if (!this._manager) this._manager = new RoomAmenityEntityManager();
        return this._manager;
    }

    /**
     * Move the room amenity to a new position.
     * 
     * @param targetObject The target object to move the room amenity to.
     * @param before If true, the room amenity will be moved before the target object. If false, the room amenity will be moved after the target object.
     */
    async moveTo(targetObject: RoomAmenity, before: boolean = true)
    {
        return BusinessEntityWithOrderNoHelper.moveTo('RoomAmenity', this, targetObject, before);
    }
}


export default RoomAmenity;